<template>
  <div>
    <div class="nav-title">
      <div
        v-for="(v, i) in title"
        :key="i"
        :class="['nav-title-item', { gray: i < title.length - 1 }]"
      >
        <span class="nav-title-item-title" @click="handleTitle(v, i)">{{
          v
        }}</span>
        <span v-if="i < title.length - 1" class="nav-title-item-icon">/</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavTitle",
  props: {
    title: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    handleTitle(v, i) {
      this.$emit("titleClick", v, i);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
